type IconProps = React.ComponentProps<'svg'>

export function Maximize01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 2.25)">
        <path
          d="M7.21973 11.2197C7.51262 10.9268 7.98738 10.9268 8.28027 11.2197C8.57317 11.5126 8.57317 11.9874 8.28027 12.2803L2.56055 18H6.75C7.16421 18 7.5 18.3358 7.5 18.75C7.5 19.1642 7.16421 19.5 6.75 19.5H0.75C0.551088 19.5 0.360379 19.4209 0.219727 19.2803C0.0790745 19.1396 0 18.9489 0 18.75V12.75C0 12.3358 0.335787 12 0.75 12C1.16421 12 1.5 12.3358 1.5 12.75V16.9395L7.21973 11.2197Z"
          fill="currentColor"
        />
        <path
          d="M18.75 0C19.1642 0 19.5 0.335786 19.5 0.75V6.75C19.5 7.16421 19.1642 7.5 18.75 7.5C18.3358 7.5 18 7.16421 18 6.75V2.56055L12.2803 8.28027C11.9874 8.57317 11.5126 8.57317 11.2197 8.28027C10.9268 7.98738 10.9268 7.51262 11.2197 7.21973L16.9395 1.5H12.75C12.3358 1.5 12 1.16421 12 0.75C12 0.335786 12.3358 0 12.75 0H18.75Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
